import { SecurityElementNames } from './../../../shared/auth/constants/security-element-names.service';
import { AccessControlEntry } from './../../../shared/auth/access-control-entry';
import { MenuItem } from 'primeng/api';
import { Component, OnInit, Input, AfterViewInit, ViewChild } from '@angular/core';
import { UtilService, DialogService, NotificationService, DatagridService, LocalStorageService } from '../../../shared/index';
import { EventRead } from '../../shared/event-read.model';
import { EventItemSummary } from '../../shared/items/event-item-summary.model';
import { TranslationService } from '../../../shared/translation/translation.service';
import { ActivatedRoute } from '@angular/router';
import { NameValue } from '../../../shared/model/name-value.model';
import { DialogResult } from '../../../shared/dialog/dialog-result.model';
import { WlEventsV4ToolbarBroadcastService } from '../../../shared/container/toolbars/module/events-v4/broadcast/index';
import { DataView as PrimeDataList } from 'primeng/dataview';
import { NavigationService } from '../../../shared/navigation/navigation.service';
import { PlatformService } from '../../../shared/platform/platform.service';
import { timeoutWrapper } from 'src/app/shared/decorator/timeout-wrapper';
import { EventTabsEnum } from '../../shared/event-tabs.enum';
import { EventV4RegistrationManagementSelectorComponent } from '../event-v4-registration-management-selector/event-v4-registration-management-selector.component';
import { EventV4RegistrationDeleteComponent } from '../event-v4-registration-delete/event-v4-registration-delete.component';
import { RegistrationAttendeeMin } from '../../shared/registration/registration-attendee-min.model';
import { RegistrationMin } from '../../shared/registration/registration-min.model';
import { RegistrationSearchParams } from '../../shared/registration/registration-search-params.model';
import { RegistrationSearchResult } from '../../shared/registration/registration-search-result.model';
import { EventV4RegistrationService } from '../../shared/registration/event-v4-registration.service';
import { EventV4ItemService } from '../../shared/items/event-v4-item.service';
import { EventsV4Service } from '../../shared/events-v4.service';
import { EventV4RegistrationWizardComponent } from '../event-v4-wizard/event-v4-registration-wizard.component';
import { EventV4CreateRegistrationProfileDialogComponent } from './event-v4-create-registration-profile-dialog/event-v4-create-registration-profile-dialog.component';
import { DeleteRegistrationResultDto } from '../../shared/registration/delete-registration-result.dto';
import { DeleteRegistrationResultEnum } from '../../shared/registration/delete-registration-result.enum';
import { AdjustmentTypeService } from '../../../revenue/shared/adjustment-types/adjustment-type.service';
import { InvoiceService } from '../../../revenue/shared/invoice/invoice.service';

@Component({
  selector: 'wl-event-v4-registration-management',
  templateUrl: './event-v4-registration-management.component.html',
  styleUrl: './event-v4-registration-management.component.less',
  providers: [WlEventsV4ToolbarBroadcastService],
  standalone: false,
})
export class EventV4RegistrationManagementComponent implements OnInit, AfterViewInit {
  @ViewChild('registrationSelector', { static: false }) registrationSelector: EventV4RegistrationManagementSelectorComponent;
  @ViewChild('registrationsDataGrid', { static: false }) public _registrationsDataGrid: PrimeDataList;
  @ViewChild('deleteDialog', { static: false }) public deleteDialog: EventV4RegistrationDeleteComponent;
  @ViewChild('registrationWizardModal', { static: false }) public _registrationWizardModal: EventV4RegistrationWizardComponent;
  @ViewChild(EventV4CreateRegistrationProfileDialogComponent) public createProfileDialog: EventV4CreateRegistrationProfileDialogComponent;

  public _registrationToDelete: RegistrationMin;

  public registrationSearchResult: RegistrationSearchResult;
  public unfilteredRegistrationSearchResult: RegistrationSearchResult = new RegistrationSearchResult();
  @Input() public event: EventRead;

  public initialLoadComplete: boolean;
  public searchParams: RegistrationSearchParams;
  public eventId: number;
  public showDetails: boolean;
  public showAdvancedSearch: boolean;
  public eventItems: Array<EventItemSummary>;
  public sortByFields: Array<NameValue>;
  public isSearching: boolean;
  public selectedAction: number;
  public actions: Array<NameValue>;
  public exporting: boolean;
  public launchedModal: boolean;
  public registrationItemMenuItems: MenuItem[];
  public rowMenuItems = new Map<number, MenuItem[]>();
  public viewOptions: any[] = [
    { icon: 'pi pi-th-large', value: false },
    { icon: 'pi pi-bars', value: true },
  ];
  public displayGrid = { icon: 'pi pi-th-large', value: false };

  public editInvoiceAccessControl: AccessControlEntry = {
    SecurityElement: this._securityElementNames.Revenue_Module,
    MinimumAccessLevel: 2,
  };

  public constructor(
    private _eventService: EventsV4Service,
    private _route: ActivatedRoute,
    private _utilService: UtilService,
    private _eventItemService: EventV4ItemService,
    private _translationService: TranslationService,
    private _registrationService: EventV4RegistrationService,
    private _dialogService: DialogService,
    private _dataGridService: DatagridService,
    private _notifyService: NotificationService,
    public _eventsToolbarBroadcastService: WlEventsV4ToolbarBroadcastService,
    public _platformService: PlatformService,
    public _navigationService: NavigationService,
    private _securityElementNames: SecurityElementNames,
    private _localStorage: LocalStorageService,
    private _adjustmentTypeService: AdjustmentTypeService,
    private _invoiceService: InvoiceService
  ) {
    this._registrationToDelete = new RegistrationMin();

    this.event = new EventRead();
    this.initialLoadComplete = false;
    this.registrationSearchResult = new RegistrationSearchResult();
    this.searchParams = new RegistrationSearchParams();
    this.searchParams.PageNumber = 1;
    this.searchParams.PageSize = 20;

    this.eventId = 0;
    this.showDetails = false;
    this.showAdvancedSearch = false;
    this.eventItems = new Array<EventItemSummary>();
    this.sortByFields = new Array<NameValue>();
    this.isSearching = false;
    this.selectedAction = 0;
    this.actions = new Array<NameValue>();
    this.exporting = false;
  }

  ngOnInit() {
    // setup sortby dropdown
    let nv1 = new NameValue();
    let nv2 = new NameValue();
    let nv3 = new NameValue();
    let nv4 = new NameValue();
    let nv5 = new NameValue();
    let nv6 = new NameValue();
    let nv7 = new NameValue();
    let nv8 = new NameValue();
    let nv9 = new NameValue();
    let nv10 = new NameValue();
    nv1.name = 'Sign Up Date (desc)';
    nv1.value = 'SignUpDate:desc';
    nv2.name = 'Sign Up Date (asc)';
    nv2.value = 'SignUpDate:asc';
    nv3.name = 'Org Name (asc)';
    nv3.value = 'OrgName:asc';
    nv4.name = 'Org Name (desc)';
    nv4.value = 'OrgName:desc';
    nv5.name = 'First Name (asc)';
    nv5.value = 'FirstName:asc';
    nv6.name = 'First Name (desc)';
    nv6.value = 'FirstName:desc';
    nv7.name = 'Last Name (asc)';
    nv7.value = 'LastName:asc';
    nv8.name = 'Last Name (desc)';
    nv8.value = 'LastName:desc';
    nv9.name = 'Amount Due (asc)';
    nv9.value = 'AmountDue:asc';
    nv10.name = 'Amount Due (desc)';
    nv10.value = 'AmountDue:desc';
    this.sortByFields.push(nv1);
    this.sortByFields.push(nv2);
    this.sortByFields.push(nv3);
    this.sortByFields.push(nv4);
    this.sortByFields.push(nv5);
    this.sortByFields.push(nv6);
    this.sortByFields.push(nv7);
    this.sortByFields.push(nv8);
    this.sortByFields.push(nv9);
    this.sortByFields.push(nv10);
    // setup actions dropdown
    this._translationService.getTitlecase('events.registration.management.actions.select-action').then((data: string) => {
      this.actions.push(new NameValue(data, 0));
    });
    this._translationService.getTitlecase('events.registration.management.actions.export-all-registrations').then((data: string) => {
      this.actions.push(new NameValue(data, 1));
    });
    this._translationService.getTitlecase('events.registration.management.actions.send-confirmation-email').then((data: string) => {
      this.actions.push(new NameValue(data, 2));
    });
    this._translationService.getTitlecase('events.registration.management.actions.view-print-all-invoices').then((data: string) => {
      this.actions.push(new NameValue(data, 3));
    });
    this._translationService.getTitlecase('events.registration.management.actions.view-print-open-invoices').then((data: string) => {
      this.actions.push(new NameValue(data, 4));
    });
    this._translationService
      .getTitlecase('events.registration.management.actions.add-selected-profiles-to-affiliation')
      .then((data: string) => {
        this.actions.push(new NameValue(data, 5));
      });
    this._translationService.getTitlecase('events.registration.management.actions.email-these-registrations').then((data: string) => {
      this.actions.push(new NameValue(data, 6));
    });
    this._translationService.getTitlecase('events.registration.management.actions.apply-payments').then((data: string) => {
      this.actions.push(new NameValue(data, 7));
    });
    this._translationService
      .getTitlecase('events.registration.management.actions.export-all-registrations-extended')
      .then((data: string) => {
        this.actions.push(new NameValue(data, 8));
      });
    this._translationService
      .getTitlecase('events.registration.management.actions.export-all-registrations-extended-excel')
      .then((data: string) => {
        this.actions.push(new NameValue(data, 10));
      });
    this._translationService
      .getTitlecase('events.registration.management.actions.export-selected-registrations-extended')
      .then((data: string) => {
        this.actions.push(new NameValue(data, 9));
      });
  }

  /**
   * called after view is initted. all view children are ready
   */
  public ngAfterViewInit(): void {
    this._route.params?.subscribe((params: any) => {
      if (this._utilService.isNotNullOrUndefined(params['id'])) {
        this.eventId = Number(params['id']);
        this.searchParams.EventId = this.eventId;
        //this.resetAndSearch();
        //do not reset just search as other compopnents like EventSettings will set some params
        //like looking for only ProfileId == 0 etc
        this.search();
        // hack replace this with an eventserviceservice
        this._eventService.getEventRead(this.eventId).then((data: any) => {
          this.event = data;
        });
        this._eventItemService.getEventItems(this.eventId).then((data: Array<any>) => {
          for (let item of data) {
            item.Selected = false;
          }
          this.eventItems = data;
        });
        this.getRegistrations();
      }
    });

    let regViewOption = this._localStorage.getObject('registration-view-option');
    if (regViewOption != null) {
      this.displayGrid = regViewOption;
    }
  }

  public lazyLoadRegistrations($event: any) {
    if (this.initialLoadComplete == true && this.isSearching == false) {
      this._dataGridService.mapDatagridPagingToPagedSearch($event, this.searchParams);
      this.getRegistrations();
    }
  }

  public pageSizeChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }

  /**
   * starts the search over at page 1
   */
  @timeoutWrapper()
  public search() {
    // datalist doesn't offer a reset() method like datatable
    (<any>this._registrationsDataGrid).first = 0;
    //this._registrationsDataGrid.updatePaginator();
    this.searchParams.PageNumber = 1;
    this.getRegistrations();
  }

  public getRegistrations() {
    this.searchParams.EventItemIds = new Array<number>();
    this.updateAttendeeTotals();

    for (let item of <any>this.eventItems) {
      if (item.Selected == true) {
        this.searchParams.EventItemIds.push(item.EventItemId);
      }
    }

    if (this.searchParams.EventId > 0) {
      this.isSearching = true;
      this._registrationService.searchRegistrations(this.searchParams).then(
        (data: RegistrationSearchResult) => {
          this._dataGridService.mapPagedResultsToPagedSearch(data, this.searchParams);

          this.registrationSearchResult = data;

          for (let reg of this.registrationSearchResult.Result) {
            reg.Selected = false;
            reg.UnkownAttendeesCount = Math.max(reg.PotentialAttendeeCount - reg.AttendeeCount + reg.BlankAttendeeCount, 0);
            this.initRegistrationMenu(reg);
          }
          this.initialLoadComplete = true;
          this.isSearching = false;
        },
        () => {
          this.isSearching = false;
        }
      );
    }
  }

  public toggleDetails(registration: RegistrationMin): void {
    if (!registration) return;

    if (registration.ShowDetails) this.closeDetails(registration);
    else this.openDetails(registration);
  }

  public openDetails(registration: RegistrationMin) {
    registration.LoadingDetails = true;
    registration.ShowDetails = true;
    this._registrationService.getRegistrationAttendeeHeaders(registration.Id).then(
      (data: Array<RegistrationAttendeeMin>) => {
        registration.Attendees = data;
        registration.LoadingDetails = false;
      },
      () => {
        registration.LoadingDetails = false;
      }
    );
  }

  public loadAttendeeDetails(registration: RegistrationMin) {
    if (!registration.Attendees || registration.Attendees.length == 0) {
      this._registrationService.getRegistrationAttendeeHeaders(registration.Id).then(
        (data: Array<RegistrationAttendeeMin>) => {
          registration.Attendees = data;
          registration.LoadingDetails = false;
        },
        () => {
          registration.LoadingDetails = false;
        }
      );
    }
  }

  public closeDetails(registration: RegistrationMin) {
    registration.ShowDetails = false;
  }

  public editRegistration(registration: RegistrationMin) {
    this.launchedModal = true;
    this._registrationWizardModal.lineItemAccountingPackageIds = [];
    this._registrationWizardModal.paymentAccountingPackageIds = [];
    this._registrationWizardModal.invoiceLineItemAccountingPackages = [];
    this._registrationWizardModal.hasRefundableCcPayment = registration.HasRefundableCCPayment;

    const openWizard = () => this._registrationWizardModal.openEventRegistrationForEventId(this.event.EventId, registration.Id);

    if (registration.InvoiceNum > 0) {
      this._invoiceService.GetInvoiceAccountingPackages(registration.InvoiceNum).then((result) => {
        this._registrationWizardModal.invoiceLineItemAccountingPackages = result.LineItemAccountingPackages;
        this._registrationWizardModal.lineItemAccountingPackageIds = result.LineItemAccountingPackages.map((x) => x.AccountingPackageID);
        this._registrationWizardModal.paymentAccountingPackageIds = result.PaymentAccountingPackages.map((x) => x.AccountingPackageID);
        openWizard();
      });
    } else {
      openWizard();
    }
  }

  public editRegistrationAttendees(registration: RegistrationMin) {
    this.launchedModal = true;
    this._registrationService.getRegistrationAttendeeHeaders(registration.Id).then(
      (data: Array<RegistrationAttendeeMin>) => {
        registration.Attendees = data;
        registration.LoadingDetails = false;
        this._registrationWizardModal.openEventRegistrationForEventId(
          this.event.EventId,
          registration.Id,
          registration.Attendees[0].AttendeeHeaderId
        );
      },
      () => {
        registration.LoadingDetails = false;
      }
    );
  }

  public handleRegistrationSaved(regId: number) {
    this.launchedModal = false;
    this.getRegistrations();
  }

  public handleRegistrationClosed() {
    this.launchedModal = false;
  }

  public viewInvoice(registration: RegistrationMin) {
    console.error(registration);
    this._registrationService.getInvoiceReport(registration.InvoiceNum).then((url) => this._navigationService.popupSafeNavigate(url));
  }

  public toggleAdvancedSearch() {
    if (this.showAdvancedSearch) this.closeAdvancedSearch();
    else this.openAdvancedSearch();
  }

  public openAdvancedSearch() {
    this.showAdvancedSearch = true;
  }

  public closeAdvancedSearch() {
    this.showAdvancedSearch = false;
  }

  public deleteRegistration(registration: RegistrationMin) {
    this._registrationToDelete = registration;
    this.deleteDialog.showDialog(
      registration.Id,
      registration.InvoiceNum,
      registration.AmountPaid > 0,
      registration.HasRefundableCCPayment
    );
  }

  public async registrationDeleteDialogHandler(result: DialogResult) {
    if (result == DialogResult.Yes) {
      if (this.deleteDialog.hasInvoice && !this.deleteDialog.modificationOptions.DoNotModifyInvoice) {
        const selectedAdjustmentType = await this._adjustmentTypeService.getAdjustmentType(
          this.deleteDialog.modificationOptions.InvoiceAdjustmentTypeId
        );
        const lineItemPackages = this.deleteDialog.invoiceAccountingPackages?.LineItemAccountingPackages ?? [];
        const hasMismatch = lineItemPackages.some(pkg => pkg.AccountingPackageID !== selectedAdjustmentType.AccountingPackageId);
        if (hasMismatch) {
          const warningMessage = this._translationService.getInstant(
            'events.registration.management.delete-registration-accounting-package-mismatch-warning'
          );
          this._dialogService.confirmYesNo(warningMessage, () => {
            const missingDefault = lineItemPackages.some((pkg) => !pkg.AdjustmentTypeID || pkg.AdjustmentTypeID <= 0);
            if (missingDefault) {
              this._notifyService.translateError(
                'events.registration.management.edit-registration-accounting-package-missing-default-adjustment-error'
              );
              return;
            }
            this.executeDeleteRegistration();
          }, null);
          return;
        }
      }

      this.executeDeleteRegistration();
    }
  }

  private executeDeleteRegistration() {
    this._dialogService.showWaitIndicator();

    this._registrationService
      .deleteRegistration(this._registrationToDelete.Id, this.deleteDialog.modificationOptions)
      .then((data: any) => {
        let flag = this.GetDeleteResultFlag(data);

        switch (flag) {
          case DeleteRegistrationResultEnum.Success | DeleteRegistrationResultEnum.RefundProcessed:
            this._notifyService.translateSuccess('events.registration.management.delete-registration-refund-success-message');
            break;
          case DeleteRegistrationResultEnum.Failure | DeleteRegistrationResultEnum.RefundFailed:
            this._notifyService.translateError('events.registration.management.delete-registration-refund-failure-message');
            return;
          case DeleteRegistrationResultEnum.Success | DeleteRegistrationResultEnum.UnappliedPaymentCreated:
            this._notifyService.translateSuccess('events.registration.management.delete-registration-unapplied-payment-created-message');
            break;
          case DeleteRegistrationResultEnum.Success:
            this._notifyService.translateSuccess('events.registration.management.delete-registration-success-message');
            break;
          case DeleteRegistrationResultEnum.SuccessWithWarnings:
            this._notifyService.translateSuccess('events.registration.management.delete-registration-success-message');
            if (data.WarningMessages.length > 0) {
              data.WarningMessages.forEach((warningMessage) => {
                this._notifyService.warn(warningMessage);
              });
            }
            break;
          case DeleteRegistrationResultEnum.Failure:
            if (data.ErrorMessages.length > 0) {
              data.ErrorMessages.forEach((errorMessage) => {
                this._notifyService.error(errorMessage);
              });
            } else {
              this._notifyService.translateError('events.registration.management.delete-registration-failure-message');
            }
            return;
        }
        this._utilService.arrayRemoveEntry(this.registrationSearchResult.Result, this._registrationToDelete);
        this.search();
      })
      .catch((error) => {
        this._notifyService.httpError(error);
      })
      .finally(() => {
        this._dialogService.closeWaitIndicator();
      });
  }
  public actionChanged(data: string) {
    this.selectedAction = parseInt(data);
  }

  public executeAction() {
    this.registrationSelector.selectedAction = this.selectedAction;
    //this.registrationSelector.registrations = this.registrationSearchResult.Result;
    //this.registrationSelector.registrationSearchResult = this.registrationSearchResult;
    this.registrationSelector.searchParams = this.searchParams;
    this.registrationSelector.searchRegistrations();

    this.registrationSelector.eventId = this.eventId;

    switch (this.selectedAction) {
      case 0:
        break;

      case 1:
        this.exporting = true;
        this._registrationService.exportRegistrations(this.eventId).then(
          (data: string) => {
            this._navigationService.popupSafeNavigate(data);
            this.exporting = false;
          },
          () => {
            this.exporting = false;
          }
        );
        break;

      case 2:
        this.registrationSelector.showDialog(this.selectedAction);
        break;

      case 3:
        this.exporting = true;
        this._registrationService.printAllEventInvoices(this.eventId).then(
          (url) => {
            this.exporting = false;
            this._navigationService.popupSafeNavigate(url);
          },
          (err) => (this.exporting = false)
        );
        break;

      case 4:
        this._registrationService.printOpenEventInvoices(this.eventId).then(
          (url) => {
            this.exporting = false;
            this._navigationService.popupSafeNavigate(url);
          },
          (err) => (this.exporting = false)
        );
        break;

      case 5:
        this.registrationSelector.showDialog(this.selectedAction);
        break;

      case 6:
        this.registrationSelector.showDialog(this.selectedAction);
        break;

      case 7:
        this.registrationSelector.registrations = this.registrationSelector.registrations.filter((x) => x.AmountPaid < x.AmountInvoiced);
        this.registrationSelector.showDialog(this.selectedAction);

        break;

      case 8:
        this.exporting = true;
        this._registrationService.exportRegistrationsExtended(this.eventId).then(
          (data: string) => {
            this._navigationService.popupSafeNavigate(data);
            this.exporting = false;
          },
          () => {
            this.exporting = false;
          }
        );
        break;

      case 10:
        this.exporting = true;
        this._registrationService.exportRegistrationsExtendedAsExcel(this.eventId).then(
          (data: string) => {
            this._navigationService.popupSafeNavigate(data);
            this.exporting = false;
          },
          () => {
            this.exporting = false;
          }
        );
        break;
      case 9:
        this.registrationSelector.eventId = this.eventId;
        this.registrationSelector.showDialog(this.selectedAction);
        break;

      default:
        break;
    }
  }

  public openCreateProfileDialog(registration: RegistrationMin) {
    this.createProfileDialog.openAssignProfileDialog(registration);
  }

  public registrationSaved(event: any) {
    this.getRegistrations();
  }

  public searchEventItemFromDashboard(eventItemId: number): void {
    this.openAdvancedSearch();

    for (let item of <any>this.eventItems) {
      if (item.EventItemId == eventItemId) {
        item.Selected = true;
      } else {
        item.Selected = false;
      }
    }

    this.getRegistrations();
  }

  /**
   * sets all the search and advanced search fields to default
   */
  public resetSearchForm() {
    this.searchParams.Keyword = '';
    this.searchParams.SearchAnySignUpDate = true;
    this.searchParams.SignUpStartDate = new Date();
    this.searchParams.SignUpEndDate = new Date();
    this.searchParams.AllUnpaid = false;
    this.searchParams.AllWithBlankAttendees = false;
    this.searchParams.AllWithProfileIdNotAssigned = false;

    if (this.eventItems) this.eventItems.forEach((x) => ((<any>x).Selected = false));
  }

  /**
   * resets the form and starts a fresh search
   */
  public resetAndSearch() {
    this.resetSearchForm();
    this.search();
  }

  /**
   * when the registration selector is closed for the given selectedAction
   * @param selectedAction
   */
  public handleRegistrationSelectorOkClick(selectedAction: number) {
    // confirmed for Apply Payments action
    if (selectedAction == 7) {
      this.resetAndSearch();
    }
  }

  /**
   * calls the attendee search with no filter to get total attendees for event
   */
  public updateAttendeeTotals(): void {
    let params = new RegistrationSearchParams();
    params.PageNumber = 1;
    params.PageSize = 1;
    params.EventId = this.eventId;

    this._registrationService.searchRegistrations(params).then((results) => (this.unfilteredRegistrationSearchResult = results));
  }

  /**
   * triggered by clicking "# with no profile id)
   */
  public handleAttendeesWithNoProfileIdClick(): void {
    this.searchParams.AllWithProfileIdNotAssigned = true;
    this.openAdvancedSearch();
    this.search();
  }

  public printRegistration(registration: RegistrationMin): void {
    if (!registration) return;

    var objRegistration: any = <any>registration;

    objRegistration._loadingConfirmationMessage = true;

    this._registrationService.getRegistrationConfirmationMessage(registration.Id).then(
      (message: string) => {
        if (message == null) return;

        this._platformService.openPlatformWindowToDisplayHtml(message);

        objRegistration._loadingConfirmationMessage = false;
      },
      (err) => {
        objRegistration._loadingConfirmationMessage = false;

        const message = this._utilService.extractErrorMessage(err);

        if (message) this._notifyService.error(message);
      }
    );
  }

  public goToInvoiceEdit(registration: RegistrationMin) {
    const queryParams = { tab: EventTabsEnum.Registrations };
    this._navigationService.setCurrentQueryParams(queryParams, this._route).then(() => {
      this._navigationService.navigateToInvoiceEdit(registration.InvoiceNum);
    });
  }

  public actionItemsForRegistration(reg: RegistrationMin) {
    if (!this.rowMenuItems.has(reg.Id)) {
      this.rowMenuItems.set(reg.Id, [
        {
          label: 'Registration',
          items: [
            {
              label: this._translationService.getInstantTitlecase('common.edit'),
              command: () => this.editRegistration(reg),
            },
            {
              label: this._translationService.getInstantTitlecase('common.print'),
              command: () => this.printRegistration(reg),
            },
            {
              label: this._translationService.getInstantTitlecase('common.delete'),
              command: () => this.deleteRegistration(reg),
            },
          ],
        },
      ]);

      if (reg.InvoiceNum > 0) {
        let items = this.rowMenuItems.get(reg.Id);
        items.push({
          label: 'Invoice',
          items: [
            {
              label: this._translationService.getInstantTitlecase('common.edit'),
              command: () => this.goToInvoiceEdit(reg),
            },
            {
              label: this._translationService.getInstantTitlecase('common.view'),
              command: () => this.viewInvoice(reg),
            },
          ],
        });
      }
    }
    return this.rowMenuItems.get(reg.Id);
  }

  public formatRegItems(reg: RegistrationMin) {
    return reg.ItemsDisplay.split(',')
      .map((string) => '<p>' + string + '</p>')
      .join('');
  }

  public storeRegViewOption() {
    this._localStorage.setObject('registration-view-option', this.displayGrid);
  }

  private initRegistrationMenu(registration: RegistrationMin) {
    Promise.all([
      this._translationService.getTitlecase('common.delete'),
      this._translationService.getTitlecase('events.registration.management.print-registration'),
    ]).then(([deleteLabel, printRegistrationLabel]) => {
      registration._menuItems = [
        {
          label: deleteLabel,
          command: () => {
            this.deleteRegistration(registration);
          },
        },
        {
          label: printRegistrationLabel,
          command: () => {
            this.printRegistration(registration);
          },
        },
      ];
    });
  }

  private GetDeleteResultFlag(requestResult: DeleteRegistrationResultDto): DeleteRegistrationResultEnum {
    let result = DeleteRegistrationResultEnum.None;

    if (requestResult.Success) {
      result |= DeleteRegistrationResultEnum.Success;
      if (requestResult.WarningMessages.length > 0) {
        result = DeleteRegistrationResultEnum.SuccessWithWarnings;
        return result;
      }
    } else {
      result |= DeleteRegistrationResultEnum.Failure;
    }

    if (requestResult.UnappliedPaymentCreated) {
      result |= DeleteRegistrationResultEnum.UnappliedPaymentCreated;
    }

    if (requestResult.RefundProcessed) {
      result |= DeleteRegistrationResultEnum.RefundProcessed;
    }

    if (requestResult.RefundFailed) {
      result |= DeleteRegistrationResultEnum.RefundFailed;
    }

    return result;
  }
}
